import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getAppointmentFeedbacks } from "api/Statistics";


interface FiltersProps {
    worker?: string,
    from_date_of_creation?: string,
    to_date_of_creation?: string,
    filter_on?: string,
    filter_source?: number | null,
    filter_type?: string | null,
    filter_import_source?: string | null
}
export const useAppointmentFeedbacks = (
    filters?: FiltersProps
) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['appointments',filters?.worker, filters?.from_date_of_creation, filters?.to_date_of_creation, filters?.filter_on, filters?.filter_source, filters?.filter_type, filters?.filter_import_source],
        () => {
            return getAppointmentFeedbacks({
                worker: filters?.worker === 'All agents' ? null : filters?.worker,
                from_date_of_creation: filters?.filter_on === 'Individual' ? filters?.from_date_of_creation : null,
                to_date_of_creation: filters?.filter_on === 'Individual' ?  filters?.to_date_of_creation : null,
                filter_on: filters?.filter_on === 'Individual' ? null : filters?.filter_on,
                filter_source: filters?.filter_source ?? null,
                filter_type: filters?.filter_type === 'All' ? null : filters?.filter_type ?? null,
                filter_import_source: filters?.filter_import_source ?? null
            });
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
        enabled: true,
        refetchOnMount: true,
    }
    );

    return {
        data,
        isLoading,
    };
};
